export default __webpack_public_path__ + "static/media/iso.sinfondo.b.0a3b5b6d.png";